import { apiV2 } from './api';

export interface ChatAdmin {
  id: number;
  name: string;
  email: string;
  initials: string;
}

export interface ChatMessage {
  id: number;
  message: string;
  created_at: string;
  admin: ChatAdmin;
}

const BASE = '/admin/chat';

export const adminChatApi = {
  async messages(): Promise<ChatMessage[]> {
    const res = await apiV2.get<{ data: ChatMessage[] }>(`${BASE}/messages`);
    return res.data.data;
  },

  async send(message: string): Promise<ChatMessage> {
    const res = await apiV2.post<{ data: ChatMessage }>(`${BASE}/messages`, { message });
    return res.data.data;
  },

  async remove(id: number): Promise<void> {
    await apiV2.delete(`${BASE}/messages/${id}`);
  },

  async heartbeat(): Promise<void> {
    await apiV2.post(`${BASE}/heartbeat`);
  },

  async presence(): Promise<ChatAdmin[]> {
    const res = await apiV2.get<{ data: ChatAdmin[] }>(`${BASE}/presence`);
    return res.data.data;
  },
};
